import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import VisionMissionPage from "./pages/VisionMissionPage";
import UniversitySection from "./pages/UniversitySection";
 import MessageSection from "./pages/MessageSection";
import ChairmanMessageSection from "./pages/ChairmanMessageSection";
import GNMCoursePage from "./pages/GNMCoursePage";
import BScNursingPage from "./pages/BScNursingPage";
import FeeStructurePage from "./pages/FeeStructurePage";
import RegistrationFormPage from "./pages/RegistrationFormPage";
import ProspectusPage from "./pages/ProspectusPage";
import AffiliationPage from "./pages/AffiliationPage";
import PlacementPage from "./pages/PlacementPage";
import Contact from "./pages/Contact";


function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/gallery" element={<Gallery />} />
         <Route path="/vision-mission" element={<VisionMissionPage />} />
         <Route path="/university" element={<UniversitySection/>} />
         <Route path="/principal-message" element={<MessageSection/>} />
         <Route path="/chairman-message" element={<ChairmanMessageSection />} /> 
         <Route path="/courses/gnm" element={<GNMCoursePage />} />
         <Route path="/courses/bsc-nursing" element={<BScNursingPage />} />
         <Route path="/fee-structure" element={<FeeStructurePage />} />
         <Route path="/admission/registration" element={<RegistrationFormPage />} />
         <Route path="/prospectus" element={<ProspectusPage />} />
         <Route path="/affiliation" element={<AffiliationPage />} />
         <Route path="/placement" element={<PlacementPage />} />
         <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;